import { gql } from "apollo-angular";

export const IMAGE_FIELDS = gql`
  fragment IMG on Asset {
    url
    description
  }
`

export const ASSET_FIELDS = gql`
fragment ASSET on Asset {
  url
  description
}`